import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/receivables/ → suscripciones con saldo pendiente (cartera).
function useReceivables() {
  return useQuery({
    queryKey: ["receivables"],
    queryFn: () => apiClient.get("/api/v1/receivables/").then((r) => r.data),
  });
}

// POST /api/v1/subscriptions/<id>/abono/ → registra un abono contra el saldo.
function useAbono() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ subscriptionId, amount, method, date }) =>
      apiClient
        .post(`/api/v1/subscriptions/${subscriptionId}/abono/`, {
          amount,
          method,
          date,
        })
        .then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["receivables"] });
      qc.invalidateQueries({ queryKey: ["owner-payments"] });
    },
  });
}

export { useReceivables, useAbono };
